import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";
const styles = theme => ({
  root: {
    flexGrow: 1,
    maxWidth: 1170,
    margin: 'auto',
  }
});
class Header extends Component {   
    routeChange = () =>{
        window.location.href = "https://rkbaaz-skyy.firebaseapp.com";
    }
    render() {
        const { classes } = this.props;
        return (
            <header className="site_header">
               <div className={classes.root}>
                    <Grid item xs={12} container>
                        <Grid item sm={6} xs={12} className="header_left">
                            <div className="site_logo">
                                <img src={require('../../assets/images/logo.png')} />
                                
                            </div>
                            <div className="saving_school">
                                <a className="">Start savings for school</a>
                            </div>
                        </Grid>
                        <Grid item sm={6} xs={12} className="header_right">
                            <span className="label">You have been invited!</span>
                            <Link to='/login'>
                                <button>SIGN IN</button>
                            </Link>
                        </Grid>
                        
                    </Grid>
                </div>
            </header>
        )
    }
}
Header.propTypes = {
    classes: PropTypes.object.isRequired,
  };
export default withStyles(styles)(Header);


// WEBPACK FOOTER //
// ./src/components/Landing/Header.js